/**
 * Texts of the secure payment page (/paiement).
 *
 * Payment methods, installments and refunds follow the FAQ (src/containers/FAQPage/faqContent.js)
 * and the terms: keep them in sync. Fees are not written here on purpose.
 */

export { CONTACT_EMAIL, REFUNDS } from '../FAQPage/faqContent';

// The 4 guarantees under the title
export const GUARANTEES = [
  { icon: 'lock', title: 'Paiement chiffré', text: 'Connexion sécurisée de bout en bout' },
  { icon: 'shield', title: 'Stripe', text: 'Certifié PCI DSS niveau 1, le plus haut niveau' },
  { icon: 'phone', title: '3D Secure', text: 'Validation par votre banque' },
  { icon: 'refund', title: 'Remboursé', text: 'Si le formateur annule' },
];

export const PARTNERS = [
  {
    id: 'stripe',
    tag: 'Paiement en une fois',
    text:
      "Stripe traite les paiements de millions d'entreprises dans le monde. Votre carte est saisie directement chez Stripe : elle ne passe jamais par Formabel.",
    points: [
      'Norme bancaire PCI DSS niveau 1',
      'Détection automatique des fraudes',
      'Remboursement sur la carte utilisée',
    ],
  },
  {
    id: 'scalapay',
    tag: '3 ou 4 fois',
    text:
      "Scalapay vous permet d'étaler le prix de votre formation sur plusieurs mois, sans intérêts. Vous choisissez Scalapay au moment de payer.",
    points: ['Sans intérêts', 'Réponse immédiate', 'Selon votre éligibilité'],
  },
];

export const PAYMENT_METHODS = [
  { id: 'bancontact', name: 'Bancontact', text: 'Carte ou appli de votre banque belge' },
  { id: 'visa', name: 'Visa', text: 'Carte de crédit ou de débit' },
  { id: 'mastercard', name: 'Mastercard', text: 'Carte de crédit ou de débit' },
  { id: 'maestro', name: 'Maestro', text: 'Carte de débit' },
  { id: 'revolut', name: 'Revolut', text: 'Depuis votre application' },
  { id: 'link', name: 'Link', text: 'Vos cartes enregistrées chez Stripe' },
  { id: 'scalapay', name: 'Scalapay', text: 'En 3 ou 4 fois sans intérêts' },
  { id: 'stripe', name: 'Page Stripe', text: 'Paiement 100 % sécurisé' },
];

// A 300 € training paid in 3 or 4 times (amounts that divide evenly)
export const INSTALLMENT_EXAMPLE = { total: 300, counts: [3, 4] };

export const SECURITY_POINTS = [
  {
    title: 'Formabel ne stocke aucune donnée de carte',
    text: 'Votre numéro de carte est saisi chez Stripe et ne passe jamais par nos serveurs.',
  },
  {
    title: 'Le plus haut niveau de sécurité bancaire',
    text: 'Stripe est certifié PCI DSS niveau 1, la norme la plus stricte du secteur.',
  },
  {
    title: 'Authentification forte (3D Secure)',
    text:
      "Votre banque peut vous demander un code ou une confirmation dans son application. Personne d'autre que vous ne peut payer avec votre carte.",
  },
];
